import { render, staticRenderFns } from "./PageFeed.pug?vue&type=template&id=54d9f55e&lang=pug&"
import script from "./PageFeed.vue?vue&type=script&lang=ts&"
export * from "./PageFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports